import { Link, NavLink } from 'react-router-dom';
import { useModal } from '@/lib/ModalContext';
import styles from './Nav.module.css';

const links = [
  { to: '/how', label: 'How' },
  { to: '/elaria', label: 'ELARIA' },
  { to: '/platforms', label: 'Platforms' },
  { to: '/trust', label: 'Trust' },
  { to: '/attorneys', label: 'Attorneys' },
];

export default function Nav() {
  const { setOpen } = useModal();
  return (
    <nav className={styles.navbar}>
      <div className={styles.inner}>
        <Link to="/" className={styles.brand} aria-label="AVOWAL home">
          <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <defs>
              <linearGradient id="av-grad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#00d4ff" />
                <stop offset="100%" stopColor="#f0b429" />
              </linearGradient>
            </defs>
            <path
              d="M20 4 L36 34 L28 34 L20 18 L12 34 L4 34 Z"
              fill="none"
              stroke="url(#av-grad)"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <circle cx="20" cy="26" r="2.5" fill="#00d4ff" />
          </svg>
          <div className={styles.brandText}>
            <span className={styles.name}>AVOWAL</span>
            <span className={styles.sub}>Powered by ELARIA</span>
          </div>
        </Link>
        <div className={styles.links}>
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                isActive ? `${styles.link} ${styles.linkActive}` : styles.link
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>
        <div className={styles.actions}>
          <button className={`${styles.btn} ${styles.btnGhost} ${styles.btnSmall}`} onClick={() => setOpen('waitlist')}>Waitlist</button>
          <button className={`${styles.btn} ${styles.btnPrimary} ${styles.btnSmall}`} onClick={() => setOpen('intake')}>Get Matched</button>
        </div>
      </div>
    </nav>
  );
}
